module.exports = __webpack_public_path__ + "img/legs-434918_1920.475a5205.jpg";